import React from 'react';
import { Page } from 'framework7-react';

export default function PaymentSuccessPage() {
  return (
    <Page noToolbar noNavbar noSwipeback loginScreen className='bg-white'>
      <div className="container container-table ">
        <div className="row vertical-center-row col-md-12 col-md-offset-12">
          <section className="pt-0 section-lg-b-space mt-3">
            <div className="custom-container p-0">              
              <div className="categories-title pb-2">
              <div className="modal-body">
          <div className="confirm-title text-center">
            <img className="img-fluid confirm-offer for-light" src={require("./../img/icon/success-payment-light.gif")} alt="success-payment" />
            <img className="img-fluid confirm-offer for-dark" src={require("./../img/icon/success-payment-dark.gif")} alt="success-payment" />
            <h2 className="dark-text text-center fw-semibold mt-2">Payment Success</h2>
            <h5 className="mt-3 dark-text text-center w-75 mx-auto">Your payment was successful!</h5>
          </div>

          <a href="/main/" className="btn theme-btn w-100 mt-4" role="button">Back to Home</a>
          {/* <a href="/main/" className="btn btn-link mt-0">Back to Home</a> */}
        </div>
              </div>          
            </div>
          </section>
        </div>
      </div>
    </Page>
  );
}
